// PagoContadoForm.js
import React, { useState, useEffect } from 'react';

const PagoContadoForm = ({ restaIngresar, addPayment, SetMensaje }) => {
    const [montoCliente, setMontoCliente] = useState('');
    const [vuelto, setVuelto] = useState(0);

    const montoRestante = restaIngresar.toFixed(2).replace('.', ',');

    // Efecto para recalcular el vuelto
    useEffect(() => {
        const pagado = parseFloat(montoCliente.replace(',', '.')) || 0;
        const restante = parseFloat(restaIngresar);
        const calcVuelto = pagado - restante;
        
        // El vuelto se da solo si el pago excede el restante
        setVuelto(Math.max(0, calcVuelto)); 
    }, [montoCliente, restaIngresar]);

    const handlePagar = (e) => {
        e.preventDefault();
        const importe = parseFloat(montoCliente.replace(',', '.'));

        // if (importe < restaIngresar) {
        //     SetMensaje("Error", `El monto ingresado ($${importe.toFixed(2).replace('.', ',')}) es menor al restante.`, 2000);
        //     return;
        // }

        // Agregar el pago (el controlador principal ajustará el monto si es necesario)
        addPayment({
            tipo: 'CONTADO',
            importe: importe,
            montoPagado: importe,
            vuelto: vuelto.toFixed(2)
        });
    };

    return (
        <form onSubmit={handlePagar} className="pago-form-container-contado">
            <h3>Pagar con Contado</h3>
            
            <div className="campo-pago">
                <label>Monto a Pagar (Restante):</label>
                <input type="text" value={`$ ${montoRestante}`} readOnly className="input-monto-readonly" />
            </div>

            <div className="campo-pago">
                <label htmlFor="montoCliente">Calcular vuelto de (Efectivo cliente):</label>
                <input 
                    id="montoCliente"
                    type="text"
                    value={montoCliente}
                    onChange={(e) => setMontoCliente(e.target.value.replace(/[^0-9,.]/g, ''))} // Permite números, comas y puntos
                    autoFocus
                    required
                />
            </div>
            
            <div className="campo-pago vuelto">
                <label>Vuelto a dar:</label>
                <input 
                    type="text" 
                    value={`$ ${vuelto.toFixed(2).replace('.', ',')}`} 
                    readOnly 
                    className="input-vuelto-readonly"
                />
            </div>

            <button type="submit" className="btn-agregar-pago">
                + Agregar Pago
            </button>
        </form>
    );
};

export default PagoContadoForm;